import wrapper from 'wrapper';
import { Events } from './gallery';

class NavButtons {
    constructor(gallery) {
        this.gallery = gallery;
        this.nextButton = gallery.dom.nextButton;
        this.prevButton = gallery.dom.prevButton;
        this.addEventHandlers();
        this.gallery.addEventListener(Events.IndexChange, () => this.render());
        this.applyVocabs();
        this.render();
    }

    render() {
        const { index } = this.gallery.state;

        const atBegin = index === 0;
        const atEnd = index === this.gallery.length() - 1;
        this.prevButton.disabled = atBegin;
        this.nextButton.disabled = atEnd;
    }

    applyVocabs() {
        this.nextButton.setAttribute('aria-label', __('next'));
        this.prevButton.setAttribute('aria-label', __('previous'));
        this.nextButton.setAttribute('title', __('next'));
        this.prevButton.setAttribute('title', __('previous'));
    }

    addEventHandlers() {
        this.prevButton.addEventListener('click', () => {
            // ATI stats for number of clicks on previous button
            wrapper.trackClick('"Previous" button clicked', 3);

            this.gallery.previous();
            this.gallery.pause();
        });
        this.nextButton.addEventListener('click', () => {
            // ATI stats for number of clicks on next button
            wrapper.trackClick('"Next" button clicked', 3);

            this.gallery.next();
            this.gallery.pause();
        });
    }
}

export default NavButtons;
